export default __webpack_public_path__ + "static/media/Create-documentation.4a27d5f8.md";